import { iorganizationManagementApiV1 as om } from '@deepup/internal-apis';
import type { Project } from '@projects/types';

export type LabelingFilterMode = 'all' | 'deep_build' | 'deep_scan';

export const formatProjectLabelingLabel = (labelingType: Project['labelingType']): string => {
  if (labelingType === undefined) {
    return '—';
  }
  if (labelingType === om.LabelingType.SCAN_ONLY) {
    return 'Deep Scan';
  }
  return 'Deep Build';
};

/** Default (DeepBuild): hide scan-only labeling; treat UNSPECIFIED and missing as DeepBuild. */
export const filterProjectsByLabeling = (
  projects: Project[],
  mode: LabelingFilterMode,
): Project[] => {
  if (mode === 'all') {
    return projects;
  }
  if (mode === 'deep_scan') {
    return projects.filter((p) => p.labelingType === om.LabelingType.SCAN_ONLY);
  }
  return projects.filter((p) => p.labelingType !== om.LabelingType.SCAN_ONLY);
};
